<template>
  <div class="messages">
    <div
      v-for="message in messages"
      :key="message.id"
      class="message"
      @click.prevent="remove(message.id)"
    >
      {{ message.message }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "GlobalMessages", // Explicit naming provides clean component debugging in Vue 3
  computed: {
    ...mapState(["messages"])
  },
  methods: {
    remove(id) {
      this.$store.dispatch("deleteMessage", id);
    }
  }
};
</script>
